'use strict';

export default (() => {

    var _self,
        ui,
        wrap;

    return {

        init: function(options) {
            _self = this;

            if (options.wrap) {
                wrap = options.wrap;
            }

            if (wrap) {
                ui = {
                    toggle: wrap.querySelector('.js-nav-breadcrumbs-toggle')
                };

                this.checkBreadcrumbLength();
                this.bindUIActions();
            }
        },

        bindUIActions: function() {
            ui.toggle.addEventListener('click', _self.events.toggleTruncate);
        },

        events: {
            toggleTruncate: function() {
                if (wrap.classList.contains('is-collapsed')) {
                    wrap.classList.remove('is-collapsed');
                    wrap.classList.add('is-expanded');
                }
            }
        },

        checkBreadcrumbLength: function() {
            if ( $(wrap).children().length <= 3 ) {
                $(wrap).removeClass('is-truncated').addClass('is-not-truncated');
            }
        }

    };
})();
